// import React, { useEffect, useState, useContext } from "react";
// import {
//     Bar,
//     Line,
//     XAxis,
//     YAxis,
//     CartesianGrid,
//     Tooltip,
//     ResponsiveContainer,
//     ComposedChart,
//     Legend,
// } from "recharts";
// import { Refresh } from "@mui/icons-material";
// import IconButton from "@mui/material/IconButton";
// import CircularProgress from "@mui/material/CircularProgress";
// import { AuthenticationContext } from "../../../../../context/AuthenticationContext";
// import { BusinessApi } from "../../../../../api/Api";

// const BusinessInnerChart4 = () => {
//     const { LoggedInUserInfo } = useContext(AuthenticationContext);
//     const [chartData, setChartData] = useState([]);
//     const [loading, setLoading] = useState(false);

//     const getCredentials = () => ({
//         LOGIN_ID: localStorage.getItem("LOGIN_ID") || "",
//         SS_KEY: localStorage.getItem("SS_KEY") || "",
//     });

//     const fetchLogData = async () => {
//         setLoading(true);
//         const credentials = getCredentials();
//         try {
//             const res = await BusinessApi(credentials);

//             if (res?.data && Array.isArray(res.data)) {
//                 const transformedData = res.data.map((item, index) => ({
//                     name: item.user || `User-${index + 1}`,
//                     TODAYS_Specific_Yield: parseFloat(item.TODAYS_Specific_Yield) || 0,

//                 }));
//                 setChartData(transformedData);
//             } else {
//                 setChartData([]);
//                 console.error("Data structure mismatch:", res);
//             }
//         } catch (err) {
//             console.error("Error fetching data:", err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchLogData();
//     }, []);

//     return (
//         <div className="row">
//             <div className="col-md-12" style={{ height: "26rem", position: "relative" }}>
//                 {/* Refresh Button */}
//                 <div
//                     style={{
//                         position: "absolute",
//                         top: "10px",
//                         right: "10px",
//                         zIndex: 1,
//                     }}
//                 >
//                     <IconButton onClick={fetchLogData} disabled={loading}>
//                         <Refresh />
//                     </IconButton>
//                     {loading && <CircularProgress size={24} style={{ marginLeft: "10px" }} />}
//                 </div>

//                 {/* Chart */}
//                 {loading ? (
//                     <div
//                         style={{
//                             display: "flex",
//                             justifyContent: "center",
//                             alignItems: "center",
//                             height: "100%",
//                         }}
//                     >
//                         <CircularProgress />
//                     </div>
//                 ) : (
//                     // Inside your JSX, replace the entire <ComposedChart> section with:

//                     <ResponsiveContainer>
//                         <ComposedChart
//                             data={chartData}
//                             margin={{ top: 20, right: 40, left: 40, bottom: 60 }}
//                         >
//                             <CartesianGrid strokeDasharray="3 3" />

//                             {/* X Axis with inverter names */}
//                             <XAxis
//                                 dataKey="name"
//                                 angle={-45}
//                                 textAnchor="end"
//                                 height={70}
//                                 tick={{ fontSize: 11, fill: "black" }}
//                                 label={{
//                                     value: "Inverters",
//                                     position: "insideBottom",
//                                     offset: -50,
//                                     fill: "white",
//                                 }}
//                             />

//                             {/* Y Axis for Todays Specific Yield - Left */}
//                             <YAxis
//                                 yAxisId="left"
//                                 tick={{ fontSize: 12, fill: "black" }}
//                                 label={{
//                                     value: "Todays Specific Yield",
//                                     angle: -90,
//                                     position: "insideLeft",
//                                     fill: "black",
//                                 }}
//                             />

//                             {/* Tooltip & Legend */}
//                             <Tooltip />
//                             <Legend layout="horizontal" verticalAlign="top" align="center" />

//                             {/* Bar for TODAYS_Specific_Yield Only */}
//                             <Bar
//                                 dataKey="TODAYS_Specific_Yield"
//                                 yAxisId="left"
//                                 fill={LoggedInUserInfo?.dash_color || "#00C49F"}
//                                 name="Today Specific Yield"
//                             />

//                         </ComposedChart>
//                     </ResponsiveContainer>


//                 )}
//             </div>
//         </div>
//     );
// };

// export default BusinessInnerChart4;

import React, { useEffect, useState, useContext , forwardRef} from "react";
import {
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ComposedChart,
  Legend,
  LabelList,
} from "recharts";
import { Refresh } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import { AuthenticationContext } from "../../../../../context/AuthenticationContext";
import { BusinessApi } from "../../../../../api/Api";

const BusinessInnerChart4 = forwardRef((props, ref) => {
  const { LoggedInUserInfo } = useContext(AuthenticationContext);
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getCredentials = () => ({
    LOGIN_ID: localStorage.getItem("LOGIN_ID") || "",
    SS_KEY: localStorage.getItem("SS_KEY") || "",
  });

  const fetchLogData = async () => {
    setLoading(true);
    const credentials = getCredentials();
    try {
      const res = await BusinessApi(credentials);

      if (res?.data && Array.isArray(res.data)) {
        const transformedData = res.data.map((item, index) => ({
          name: item.user || `User-${index + 1}`,
          TODAYS_Specific_Yield: parseFloat(item.TODAYS_Specific_Yield) || 0,
        }));
        setChartData(transformedData);
      } else {
        setChartData([]);
        console.error("Data structure mismatch:", res);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogData();
  }, []);

  return (
    <div ref={ref} className="row">
      <div className="col-md-12" style={{ height: "26rem", position: "relative" }}>
        {/* Refresh Button */}
        <div
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            zIndex: 1,
          }}
        >
          <IconButton onClick={fetchLogData} disabled={loading}>
            <Refresh />
          </IconButton>
          {loading && <CircularProgress size={24} style={{ marginLeft: "10px" }} />}
        </div>

        {/* Chart */}
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <ResponsiveContainer>
            <ComposedChart
              data={chartData}
              margin={{ top: 40, right: 40, left: 40, bottom: 60 }} /* top margin increased for label space */
            >
              <CartesianGrid strokeDasharray="3 3" />

              {/* X Axis with inverter names */}
              <XAxis
                dataKey="name"
                angle={-45}
                textAnchor="end"
                height={70}
                tick={{ fontSize: 11, fill: "black" }}
                // label={{
                //   value: "Inverters",
                //   position: "insideBottom",
                //   offset: -50,
                //   fill: "black",
                // }}
              />

              {/* Y Axis for Todays Specific Yield - Left */}
              <YAxis
                yAxisId="left"
                tick={{ fontSize: 12, fill: "black" }}
                label={{
                  value: "Todays Specific Yield",
                  angle: -90,
                  position: "insideLeft",
                  fill: "black",
                }}
              />

              {/* Tooltip & Legend */}
              <Tooltip />
              <Legend layout="horizontal" verticalAlign="top" align="center" />

              {/* Bar for TODAYS_Specific_Yield with value labels */}
              <Bar
                dataKey="TODAYS_Specific_Yield"
                yAxisId="left"
                fill={LoggedInUserInfo?.dash_color || "#00C49F"}
                name="Today Specific Yield"
              >
                {/* <LabelList dataKey="TODAYS_Specific_Yield" position="top" /> */}
                <LabelList dataKey="TODAYS_Specific_Yield" position="top" fill="#00C49F"  style={{ fontSize: 14 }}/>

              </Bar>
            </ComposedChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
});

export default BusinessInnerChart4;
